export default {
  name: 'marking--updH',
  apiService: 'shoes',
  apiPath: '/admin/upd_h',
};